import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const pageNumbers = [];

  if (totalPages <= 5) {
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  } else {
    if (currentPage <= 3) {
      pageNumbers.push(1, 2, 3, 4, 5, '...', totalPages);
    } else if (currentPage > totalPages - 3) {
      pageNumbers.push(
        1,
        '...',
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages
      );
    } else {
      pageNumbers.push(
        1,
        '...',
        currentPage - 1,
        currentPage,
        currentPage + 1,
        '...',
        totalPages
      );
    }
  }

  return (
    <div className="flex justify-center md:justify-start items-center space-x-2 mt-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`w-7 h-7 flex justify-center items-center text-xs rounded ${
          currentPage === 1
            ? 'hidden border-secondary'
            : 'bg-transparent border-secondary hover:bg-white border-[1px]'
        }`}
      >
        <ChevronLeftIcon className="h-4 w-4 text-secondary" />
      </button>
      {pageNumbers.map((page, index) =>
        typeof page === 'number' ? (
          <button
            key={index}
            onClick={() => onPageChange(page)}
            className={`w-7 h-7 flex justify-center items-center text-xs border rounded ${
              currentPage === page
                ? 'bg-secondary text-white border-secondary'
                : 'bg-transparent border-secondary hover:bg-white'
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={index} className="px-3 py-1">
            {page}
          </span>
        )
      )}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`w-7 h-7 flex justify-center items-center text-xs border rounded ${
          currentPage === totalPages
            ? 'hidden'
            : 'bg-transparent hover:bg-white border-[1px] border-secondary'
        }`}
      >
        <ChevronRightIcon className="h-4 w-4 text-secondary" />
      </button>
    </div>
  );
};

export default Pagination;
